import React, { useState } from 'react'
import {
  Modal,
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider,
  Paper,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import CloseIcon from '@mui/icons-material/Close'
import textToSpeech from '../../api/TextToSpeech'

const WeighingModal = ({ open, onClose, teamName, teamId, onSave, sector }) => {
  const [fishType, setFishType] = useState('карп')
  const [weight, setWeight] = useState('')
  const [caughtFish, setCaughtFish] = useState([])

  const handleAddFish = () => {
    if (!weight || isNaN(parseFloat(weight))) return
    const formatW = formatWeight(parseFloat(weight))
    console.log(formatW.variant1)
    const text = fishType + ' ' + formatW.variant1
    textToSpeech.speak(text, {
      lang: 'ru-RU',
      rate: 1,
      pitch: 1,
      onStart: () => console.log('Speech started'),
      onEnd: () => console.log('Speech ended'),
      onError: (e) => console.error('Error:', e),
    })

    setCaughtFish((prev) => [
      ...prev,
      {
        type: fishType,
        weight: parseFloat(weight),
        timestamp: new Date().getTime(),
      },
    ])
    setWeight('')
    setFishType('карп')
  }
  function formatWeight(grams) {
    // Проверяем, что входное значение - число
    if (typeof grams !== 'number' || isNaN(grams)) {
      return { variant1: 'Некорректный ввод', variant2: 'Некорректный ввод' }
    }

    const kilograms = Math.floor(grams / 1000)
    const remainingGrams = grams % 1000

    // Вариант 1: полные слова
    let variant1 = ''
    if (kilograms > 0) {
      variant1 += `${kilograms} килограмм${getRussianEnding(kilograms)}`
      if (remainingGrams > 0) {
        variant1 += ` ${remainingGrams} грамм${getRussianEnding(remainingGrams)}`
      }
    } else {
      variant1 = `${remainingGrams} грамм${getRussianEnding(remainingGrams)}`
    }

    // Вариант 2: сокращенные обозначения
    const variant2 = `${kilograms} кг. ${remainingGrams} гр.`

    return { variant1, variant2 }
  }

  // Функция для правильного склонения русских слов
  function getRussianEnding(num) {
    const lastTwo = num % 100
    const lastOne = num % 10

    if (lastTwo >= 11 && lastTwo <= 14) {
      return 'ов'
    }

    switch (lastOne) {
      case 1:
        return ''
      case 2:
      case 3:
      case 4:
        return 'а'
      default:
        return ''
    }
  }
  const handleRemoveFish = (index) => {
    setCaughtFish((prev) => prev.filter((_, i) => i !== index))
  }

  const totalWeight = caughtFish.reduce((sum, fish) => sum + fish.weight, 0)

  const handleSubmit = async () => {
    const formatW = formatWeight(parseFloat(totalWeight))
    const textVoice =
      'Результат. Рыб: ' +
      caughtFish.length +
      ', общий вес: ' +
      formatW.variant1

    const text =
      'Закрыть взвешивание? Всего рыб: ' +
      caughtFish.length +
      ', общий вес: ' +
      formatW.variant2

    textToSpeech.speak(textVoice, {
      lang: 'ru-RU',
      rate: 1,
      pitch: 1,
    })
    // eslint-disable-next-line no-restricted-globals
    const result = confirm(text)
    if (result) {
      onSave({
        admin: 0,
        time: new Date().getTime(),
        teamId,
        teamName,
        fishList: caughtFish,
        totalWeight,
        fishCount: caughtFish.length,
      })

      setCaughtFish([])
      setWeight('')
      setFishType('карп')
      onClose()
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        sx={{
          width: '90%',
          maxWidth: 800,
          maxHeight: '90vh',
          overflow: 'auto',
          p: 3,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" gutterBottom>
            Сектор №{sector} команда {teamName}
          </Typography>
          <IconButton
            onClick={() => {
              setCaughtFish([])
              setWeight('')
              setFishType('карп')
              onClose()
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography variant="body1" gutterBottom>
          Введите тип и вес каждой выловленной рыбы
        </Typography>

        <Select
          value={fishType}
          onChange={(e) => setFishType(e.target.value)}
          sx={{ width: '100%' }}
        >
          <MenuItem value="карп">Карп</MenuItem>
          <MenuItem value="амур">Амур</MenuItem>
        </Select>
        <Box display="flex" gap={2} mt={2} mb={4}>
          <TextField
            label="Вес (гр)"
            type="tel"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            sx={{ flexGrow: 1 }}
          />

          <Button
            variant="contained"
            onClick={handleAddFish}
            disabled={!weight || isNaN(parseFloat(weight))}
          >
            Добавить
          </Button>
        </Box>

        {caughtFish.length > 0 && (
          <>
            <Typography variant="h6" gutterBottom>
              Список рыбы:
            </Typography>
            <List
              sx={{
                width: '100%',

                bgcolor: 'background.paper',
                position: 'relative',
                overflow: 'auto',
                maxHeight: 300,
                '& ul': { padding: 0 },
              }}
              subheader={<li />}
            >
              {caughtFish.map((fish, index) => (
                <ListItem
                  key={index}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      onClick={() => handleRemoveFish(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                  <ListItemText
                    primary={`${fish.type}`}
                    secondary={`${fish.weight}`}
                  />
                </ListItem>
              ))}
            </List>

            <Typography variant="body1" gutterBottom>
              Всего выловлено: {caughtFish.length} шт.
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ mb: 3 }}>
              Общий вес: {totalWeight}
            </Typography>
          </>
        )}

        <Divider sx={{ my: 2 }} />

        <Box display="flex" justifyContent="space-between">
          {/* <Button
            variant="outlined"
            onClick={() => {
              setCaughtFish([])
              setWeight('')
              setFishType('карп')

              onClose()
            }}
          >
            Закрыть
          </Button> */}

          <Button
            variant="outlined"
            color="secondary"
            onClick={() => {
              setCaughtFish([])
              setWeight('')
              setFishType('карп')

              onSave({
                admin: 0,
                time: new Date().getTime(),
                teamId,
                teamName,
                fishList: [
                  {
                    type: 'карп',
                    weight: 0,
                    timestamp: new Date().getTime(),
                  },
                ],
                totalWeight: 0,
                fishCount: 0,
              })
            }}
            disabled={caughtFish.length > 0}
          >
            Нет улова
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={handleSubmit}
            disabled={caughtFish.length === 0}
          >
            Сохранить
          </Button>
        </Box>
      </Paper>
    </Modal>
  )
}

export default WeighingModal
